import { ReactNode } from "react";
import classNames from "../../../../utils/classNames";
import PriceFormat from "../../../../utils/priceFormat";

export default function SummaryStatTile({
  label,
  value,
  icon,
  valueClassName = "text-gray-900",
}: {
  label: string;
  value: number | null;
  icon: ReactNode;
  valueClassName?: string;
}) {
  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
      <div className="mb-1 flex items-center gap-1.5">
        {icon}
        <span className="text-[10px] font-semibold uppercase tracking-wider text-gray-500">
          {label}
        </span>
      </div>
      <p className={classNames("text-sm font-bold", valueClassName)}>
        {value != null ? PriceFormat(value) : "—"}
      </p>
    </div>
  );
}